export default __webpack_public_path__ + "static/media/leo.f26f7a8d.png";